import maps from './map'

const apis = {
    maps,
}

export default apis